import React, { Component } from 'react'
import { Util } from '../../../config/Util';
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClock, faExclamationCircle, faLightbulb, faCogs } from '@fortawesome/free-solid-svg-icons';
import './EmplHome.css';
import { HiOutlineSpeakerWave } from "react-icons/hi2";
import { HiOutlineBookOpen } from "react-icons/hi2";
import { RiGraduationCapLine } from "react-icons/ri";
import { error } from 'jquery';

export default class EmplHome extends Component {

  constructor() {
    super();

    this.trainingStatus = {
      completed: [],
      pending: [],
      overdue: []
    };
    this.communicationStatus = {
      completed: [],
      pending: [],
      overdue: []
    };
    this.assessmentStatus = {
      completed: [],
      pending: [],
      overdue: []
    };
    this.state = {
      loader: false,
      training: {
        nc: 0,
        c: 0,
        od: 0
      },
      communication: {
        nc: 0,
        c: 0,
        od: 0
      },
      assessment: {
        nc: 0,
        c: 0,
        od: 0
      },
      ibtikar: {
        submissions: {
          total: 0,
          statuses: { open: 0, review: 0, implementation: 0, completed: 0, rejected: 0 }
        },
        implementations: {
          total: 0,
          statuses: { open: 0, review: 0, implementation: 0, completed: 0, rejected: 0 }
        }
      }
    }
  }


  componentDidMount() {
    const auth = Util.getFromSession("auth");
    const userId = auth && auth.id ? auth.id : Util.userId;
    this.setState({ loader: true });

    const userDetailPromise = axios.get(API.getUserDetail + userId).then((response) => {
      if (response.status === 200 && response.data.status === 'S') {  
         console.log(response.data);
         Util.saveToSession("userData", response?.data);
         // notify other components that userData in session changed
         try {
           window.dispatchEvent(new Event('userDataUpdated'));
         } catch (e) {
           // noop for environments that don't support Window event dispatch
         }
      }else{
        console.error("Failed to fetch user data:", response.data.message);
      }
    }).catch(error => {
      console.error("Error fetching user data:", error);  
    }).finally(() => {
       this.findNumbersOfTraining();
        this.findNumbersOfCommunication();
        this.findNumbersOfAssessment();
    });

    const ibtikarPromise = this.fetchIbtikarOverview();

    Promise.all([userDetailPromise, ibtikarPromise]).finally(() => {
      this.setState({ loader: false });
    });
  }

  fetchIbtikarOverview = async () => {
    const auth = Util.getFromSession("auth");
    const userId = auth && auth.id ? auth.id : Util.userId;
    if (!userId) return;

    try {
      const resp = await axios.get(API.myIdeas, { params: { userId } });
      if (resp && resp.data && resp.data.status === 'S' && Array.isArray(resp.data.ideas)) {
        const ideas = resp.data.ideas;
        
        const submissions = ideas.filter(idea => Number(idea.empUserId) === Number(userId));
        const implementations = ideas.filter(idea => Number(idea.assignee) === Number(userId));
        
        this.setState({
          ibtikar: {
            submissions: {
              total: submissions.length,
              statuses: this.getIdeasStatusCount(submissions)
            },
            implementations: {
              total: implementations.length,
              statuses: this.getIdeasStatusCount(implementations)
            }
          }
        });
      }
    } catch (err) {
      console.error("Error fetching Ibtikar overview:", err);
    }
  }

  getIdeasStatusCount = (ideasList) => {
    const counts = {
      open: 0,
      review: 0,
      implementation: 0,
      completed: 0,
      rejected: 0
    };
    
    ideasList.forEach(idea => {
      if (idea && idea.status) {
        const status = String(idea.status).toLowerCase();
        if (status.includes('open')) {
          counts.open++;
        } else if (status.includes('review')) {
          counts.review++;
        } else if (status.includes('implementation')) {
          counts.implementation++;
        } else if (status.includes('completed')) {
          counts.completed++;
        } else if (status.includes('rejected')) {
          counts.rejected++;
        } else {
          if (!counts[status]) {
            counts[status] = 0;
          }
          counts[status]++;
        }
      }
    });
    return counts;
  }

  findNumbersOfAssessment = () => {
    let completedT = [];
    let pendingT = [];
    let overdueT = [];
    const data = Util.getFromSession("userData");
    const assessments = data.assessments || [];
    assessments.forEach(element => {
      if (element.status === 'NotCompleted' || element.status === 'Failed') {
        //check due date
        if (new Date() > new Date(element.dueDate)) {
          overdueT.push(element);
        } else {
          pendingT.push(element);
        }
      } else if (element.status === 'Completed') {
        completedT.push(element);
      }
    });
    const obj = {
      nc: pendingT.length,
      c: completedT.length,
      od: overdueT.length
    }
    this.assessmentStatus.completed = completedT;
    this.assessmentStatus.pending = pendingT;
    this.assessmentStatus.overdue = overdueT;
    console.log("Assessment Status:", obj);
    this.setState({ assessment: obj })
  }
  findNumbersOfTraining = () => {
    let completedT = [];
    let pendingT = [];
    let overdueT = [];
    const data = Util.getFromSession("userData");
    const trainings = data.trainings || [];
    trainings.forEach(element => {
      if (element.status === 'NotCompleted' || element.status === 'Failed') {
        //check due date
        if (new Date() > new Date(element.dueDate)) {
          overdueT.push(element);
        } else {
          pendingT.push(element);
        }
      } else if (element.status === 'Completed') {
        completedT.push(element);
      }
    });
    const obj = {
      nc: pendingT.length,
      c: completedT.length,
      od: overdueT.length
    }
    this.trainingStatus.completed = completedT;
    this.trainingStatus.pending = pendingT;
    this.trainingStatus.overdue = overdueT;

    this.setState({ training: obj })
  }

  findNumbersOfCommunication = () => {
    let completedT = [];
    let pendingT = [];
    let overdueT = [];
    const data = Util.getFromSession("userData");
    const communication = data.communications || [];
    communication.forEach(element => {
      if (element.status === 'NotCompleted' || element.status === 'Failed') {
        //check due date
        if (new Date() > new Date(element.dueDate)) {
          overdueT.push(element);
        } else {
          pendingT.push(element);
        }
      } else if (element.status === 'Completed') {
        completedT.push(element);
      }
    });
    const obj = {
      nc: pendingT.length,
      c: completedT.length,
      od: overdueT.length
    }
    this.communicationStatus.completed = completedT;
    this.communicationStatus.pending = pendingT;
  this.communicationStatus.overdue = overdueT;

    this.setState({ communication: obj })
  }

  render() {
    const ibtikar = this.state.ibtikar || {
      submissions: { total: 0, statuses: { open: 0, review: 0, implementation: 0, completed: 0, rejected: 0 } },
      implementations: { total: 0, statuses: { open: 0, review: 0, implementation: 0, completed: 0, rejected: 0 } }
    };
    return (
      <div>
        <Loader loading={this.state.loader}></Loader>
        <div className='bread-crumb overflow-auto'>
          <div>
            <span className='breadcrumb-title'>
              <input type='button' className='btn' value='Home'></input>
            </span>

          </div>
        </div>
        <div className='mt-4 mb-5'>
          {/* Learning Overview Title */}
          <div className="learning-section-title">
            <span>Learning Overview</span>
          </div>

          <div className='row m-auto empl-overview'>
            <div className="card col-lg-4 col-md-4" >
              <div className="card-body completed">
                <div className="card-title mb-0">
                  <div className='emp-card-icon'>
                    <span><FontAwesomeIcon icon={faCheckCircle} /></span>
                  </div>
                  <h4>COMPLETED : <span>{this.state.training.c + this.state.communication.c + this.state.assessment.c}</span></h4>
                </div>
                <div className='card-detail-block'>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineSpeakerWave /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Communication : </p>
                      <h6>{this.communicationStatus.completed.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineBookOpen /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Training : </p>
                      <h6>{this.trainingStatus.completed.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><RiGraduationCapLine /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Assessment : </p>
                      <h6>{this.assessmentStatus.completed.length}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card card col-lg-4 col-md-4" >
              <div className="card-body pending">
                <div className="card-title mb-0">
                  <div className='emp-card-icon'>
                    <span><FontAwesomeIcon icon={faClock} /></span>
                  </div>
                  <h4>PENDING : <span>{this.state.training.nc + this.state.communication.nc + this.state.assessment.nc}</span></h4>
                </div>
                <div className='card-detail-block'>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineSpeakerWave /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Communication : </p>
                      <h6>{this.communicationStatus.pending.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineBookOpen /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Training : </p>
                      <h6>{this.trainingStatus.pending.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><RiGraduationCapLine /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Assessment : </p>
                      <h6>{this.assessmentStatus.pending.length}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card card col-lg-4 col-md-4" >
              <div className="card-body overdue">
                <div className="card-title mb-0">
                  <div className='emp-card-icon'>
                    <span><FontAwesomeIcon icon={faExclamationCircle} /></span>
                  </div>
                  <h4>OVERDUE : <span>{this.state.training.od + this.state.communication.od + this.state.communication.od}</span></h4>
                </div>
                <div className='card-detail-block'>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineSpeakerWave /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Communication : </p>
                      <h6>{this.communicationStatus.overdue.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><HiOutlineBookOpen /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Training : </p>
                      <h6>{this.trainingStatus.overdue.length}</h6>
                    </div>
                  </div>
                  <div className='emp-detail-block'>
                    <div className='detail-icon'>
                      <span><RiGraduationCapLine /></span>
                    </div>
                    <div className='emp-detail-count'>
                      <p>Assessment : </p>
                      <h6>{this.assessmentStatus.overdue.length}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Ibtikar Overview Section */}
          <div className="ibtikar-section-title">
            <span>Ibtikar Overview</span>
          </div>

          <div className="ibtikar-row">
            {/* Submissions Card */}
            <div className="ibtikar-card">
              <div className="ibtikar-card-header">
                <h5 className="ibtikar-card-title">
                  <FontAwesomeIcon icon={faLightbulb} className="me-2 text-warning" />
                  My Submissions
                </h5>
                <span className="ibtikar-total-badge">
                  Total: {ibtikar.submissions.total}
                </span>
              </div>
              <div className="ibtikar-status-grid">
                <div className="ibtikar-status-item status-open">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.open || 0}</span>
                  <span className="ibtikar-status-label">Open</span>
                </div>
                <div className="ibtikar-status-item status-review">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.review || 0}</span>
                  <span className="ibtikar-status-label">Review</span>
                </div>
                <div className="ibtikar-status-item status-implementation">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.implementation || 0}</span>
                  <span className="ibtikar-status-label">Implementation</span>
                </div>
                <div className="ibtikar-status-item status-completed">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.completed || 0}</span>
                  <span className="ibtikar-status-label">Completed</span>
                </div>
                <div className="ibtikar-status-item status-rejected">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.rejected || 0}</span>
                  <span className="ibtikar-status-label">Rejected</span>
                </div>
              </div>
            </div>

            {/* Implementation Card */}
            <div className="ibtikar-card">
              <div className="ibtikar-card-header">
                <h5 className="ibtikar-card-title">
                  <FontAwesomeIcon icon={faCogs} className="me-2 text-primary" />
                  My Assigned Implementations
                </h5>
                <span className="ibtikar-total-badge">
                  Total: {ibtikar.implementations.total}
                </span>
              </div>
              <div className="ibtikar-status-grid">
                <div className="ibtikar-status-item status-open">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.open || 0}</span>
                  <span className="ibtikar-status-label">Open</span>
                </div>
                <div className="ibtikar-status-item status-review">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.review || 0}</span>
                  <span className="ibtikar-status-label">Review</span>
                </div>
                <div className="ibtikar-status-item status-implementation">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.implementation || 0}</span>
                  <span className="ibtikar-status-label">Implementation</span>
                </div>
                <div className="ibtikar-status-item status-completed">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.completed || 0}</span>
                  <span className="ibtikar-status-label">Completed</span>
                </div>
                <div className="ibtikar-status-item status-rejected">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.rejected || 0}</span>
                  <span className="ibtikar-status-label">Rejected</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}
